import V from 'voca';
import ExpandableTextComponent from '72cms-ui/components/form-elements/ExpandableTextComponent';

export default {
    sections: ['details', 'image', 'meta data'],
    groups: {
        service_details: {
            component: {
                template: `<div class="form-row">
                    <slot name="firstname" />
                    <slot name="lastname" />
                    <slot name="title" />
                </div>`
            }
        }
    },
    toolbar: ['add', 'edit', 'active', 'delete'],
    fields: {
        name: {
            section: 'details',
            position: 1,
        },
        
        intro: {
            section: 'details',
            component: ExpandableTextComponent,
            position: 4,
        },
        content: {
            section: 'details',
            position: 5,
        },
        image: {
            section: 'image',
            position: 0,
            description: 'Please resize images to 460px x 285px prior to uploading. The filesize of your image should not exceed <strong>200k</strong>',
        },

        name_id: {
            label: 'Page URL',
            section: 'meta data',
            position: 2,
            description: 'This field will be populated based on page name if left blank',
            prefix: '/service/',
            listener: function (entry, entries, $form) {
                if (entry.name == 'name' && entry.newValue && !this.value) {
                    this.value = V.slugify(entry.newValue);
                }
            }
        },

        meta_description: {
            section: 'meta data',
            position: 3,
            component: ExpandableTextComponent,
        },

        meta_keywords: {
            section: 'meta data',
            position: 4,
            component: ExpandableTextComponent,
        },
    }
}




// WEBPACK FOOTER //
// ./resources/assets/cms/js/config/form.service.js